/** Never adopt older unscoped drafts: their owner cannot be inferred safely. */
export type StorageIdentity = { user_id: string; customer_id: string };
export function scopedBrowserStorageKey(namespace: string, identity: StorageIdentity | null): string | null {
  return identity ? `${namespace}:${JSON.stringify([identity.customer_id, identity.user_id])}` : null;
}
